module.exports = __webpack_public_path__ + "38b30fa0229248d8bd3a14c802046743.ttf";